var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { currencyFormat, useForceUpdate } from '../../lib/misc.functions';
import { tjkBetSlipActionSubject, tjkBetSlipOptions, tjkBetSlipVisibleSubject, tjkBettingTypesMap2, tjkFobBettingTypes, tjkFobHorseSelectionTypes, tjkLongtermBettingTypes, } from './tjk.store';
import { clearTjkBetSlip, getbetCount, PlayTjkCoupon, PlayTjkFobCoupon, PlayTjkLongtermCoupon, setTjkBetSlipMultiply, setTjkUsePointBalance, updateBetCount, } from './tjk.betslip.service';
import { tjkBetslipStore } from './components/tjk.betslip';
import { member } from '../../store/login.store';
import { modalServiceSubject } from '../../components/modal/modal';
import Trash from '../../assets/feather/trash-2.svg';
import Save from '../../assets/feather/save.svg';
import './tjk.bilet.onay.css';
function getOddsForItem(item) {
    var _a;
    var fobTypeId = Number(item.bettingType.id);
    var horseNo = item.horse.no;
    var eventOdds = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds;
    if (!eventOdds)
        return '-';
    if (fobTypeId === 1886) {
        var e_1 = eventOdds["".concat(horseNo, "T2")];
        return (e_1 === null || e_1 === void 0 ? void 0 : e_1.win_odds) > 1 ? Number(e_1.win_odds).toFixed(2) : '-';
    }
    if (fobTypeId === 1887) {
        var e_2 = eventOdds["".concat(horseNo, "T3")];
        return (e_2 === null || e_2 === void 0 ? void 0 : e_2.win_odds) > 1 ? Number(e_2.win_odds).toFixed(2) : '-';
    }
    if (fobTypeId === 1888) {
        var e_3 = eventOdds["".concat(horseNo, "T4")];
        return (e_3 === null || e_3 === void 0 ? void 0 : e_3.win_odds) > 1 ? Number(e_3.win_odds).toFixed(2) : '-';
    }
    if (fobTypeId === 1882) {
        var e_4 = eventOdds[Number(horseNo)];
        return (e_4 === null || e_4 === void 0 ? void 0 : e_4.status) === 'o' ? 'KO' : '-';
    }
    var e = eventOdds[Number(horseNo)];
    return (e === null || e === void 0 ? void 0 : e.win_odds) > 1 ? Number(e.win_odds).toFixed(2) : '-';
}
function groupNonKombine(items) {
    var groups = items.reduce(function (acc, item) {
        var key = "".concat(item.hippodrome.id, "__").concat(item.bettingType.id, "__").concat(item.run.no);
        if (!acc[key])
            acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {});
    // İkili/Sıralı İkili çiftlerinde "1. At/2. At" ve oddId araması column'a
    // göre sıralanmış sıraya dayanıyor (1884'te küçük numara, 1885'te seçim sırası).
    Object.values(groups).forEach(function (arr) { return arr.sort(function (a, b) { return a.column - b.column; }); });
    return groups;
}
export function TjkBiletOnay() {
    var _a, _b, _c, _d, _e;
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        document.body.classList.add('tjk-bilet-onay-active');
        return function () { return document.body.classList.remove('tjk-bilet-onay-active'); };
    }, []);
    useEffect(function () {
        var sub = tjkBetSlipActionSubject.subscribe(function () { return forceUpdate(); });
        return function () { return sub.unsubscribe(); };
    }, []);
    if (!tjkBetSlipOptions.hippodrome || !tjkBetSlipOptions.bettingType || !tjkBetSlipOptions.bettingSubType) {
        return (_jsxs("div", __assign({ style: { padding: 30, textAlign: 'center' } }, { children: [_jsx("p", __assign({ style: { color: 'var(--color-text-medium)', marginBottom: 16 } }, { children: "Kuponunuz bo\u015F." }), void 0), _jsx("button", __assign({ className: "btn btn-primary", onClick: function () { return navigate(-1); } }, { children: "Geri D\u00F6n" }), void 0)] }), void 0));
    }
    var isFob = tjkFobBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id));
    var isLongterm = tjkLongtermBettingTypes.includes(Number(tjkBetSlipOptions.bettingType.id));
    // FOB items
    var allFobItems = tjkBetslipStore.filter(function (el) {
        return tjkFobBettingTypes.includes(Number(el.bettingType.id));
    });
    var kombineItems = allFobItems.filter(function (el) { return Number(el.bettingType.id) === 1883; });
    var nonKombineItems = allFobItems.filter(function (el) { return Number(el.bettingType.id) !== 1883; });
    var nonKombineGroups = groupNonKombine(nonKombineItems);
    // Müşterek items
    var mutuelItems = tjkBetslipStore.filter(function (el) {
        return el.hippodrome.id === tjkBetSlipOptions.hippodrome.id &&
            el.bettingType.id === tjkBetSlipOptions.bettingType.id &&
            el.bettingSubType === tjkBetSlipOptions.bettingSubType;
    });
    // Longterm item
    var longtermItem = tjkBetslipStore.find(function (el) { var _a; return tjkLongtermBettingTypes.includes(Number((_a = el.bettingType) === null || _a === void 0 ? void 0 : _a.id)); });
    // Stats
    var betCount = getbetCount();
    var betSlipMultiply = Number(tjkBetSlipOptions.betSlipMultiply) || 1;
    var fobBaseAmount = 0;
    if (kombineItems.length >= 2)
        fobBaseAmount += Number(kombineItems[0].bettingType.price || 0);
    for (var _i = 0, _f = Object.values(nonKombineGroups); _i < _f.length; _i++) {
        var items = _f[_i];
        var typeId = Number(items[0].bettingType.id);
        var price = Number(items[0].bettingType.price || 0);
        if (tjkFobHorseSelectionTypes.includes(typeId)) {
            if (items.length >= 2)
                fobBaseAmount += price;
        }
        else {
            fobBaseAmount += items.length * price;
        }
    }
    var longtermAmount = longtermItem ? Number(tjkBetSlipOptions.bettingType.price || 1) : 0;
    var baseAmount = isLongterm ? longtermAmount : (isFob ? fobBaseAmount : betCount * tjkBetSlipOptions.bettingType.price);
    var couponAmount = baseAmount * betSlipMultiply;
    var maxCouponAmount = ((_a = tjkBetSlipOptions.bettingType) === null || _a === void 0 ? void 0 : _a.maxCouponAmount) || 12000;
    var isOverLimit = couponAmount > maxCouponAmount;
    // FOB odds
    var getCombinedOdds = function () {
        return kombineItems.reduce(function (acc, item) {
            var _a, _b, _c;
            var odds = (_c = (_b = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds) === null || _b === void 0 ? void 0 : _b[Number(item.horse.no)]) === null || _c === void 0 ? void 0 : _c.win_odds;
            return odds > 1 ? acc * odds : acc;
        }, 1);
    };
    var getGroupExactaOdds = function (items) {
        if (items.length < 2)
            return '-';
        var typeId = Number(items[0].bettingType.id);
        var run = items[0].run;
        var eventOdds = run === null || run === void 0 ? void 0 : run.event_odds;
        if (!eventOdds)
            return '-';
        var h1 = items[0].horse.no;
        var h2 = items[1].horse.no;
        var key = typeId === 1885 ? "".concat(h1, "-").concat(h2, "EX") : "".concat(h1, "-").concat(h2);
        var e = eventOdds[key];
        return (e === null || e === void 0 ? void 0 : e.win_odds) > 1 ? Number(e.win_odds).toFixed(2) : '-';
    };
    var getTotalOdds = function () {
        var _a;
        if (isLongterm) {
            var odds = (_a = longtermItem === null || longtermItem === void 0 ? void 0 : longtermItem.horse) === null || _a === void 0 ? void 0 : _a.win_odds;
            return odds > 1 ? Number(odds).toFixed(2) : '-';
        }
        if (kombineItems.length >= 2) {
            var odds = getCombinedOdds();
            return odds > 1 ? odds.toFixed(2) : '-';
        }
        if (nonKombineItems.length > 0) {
            var isExacta = tjkFobHorseSelectionTypes.includes(Number(nonKombineItems[0].bettingType.id));
            var total = 1;
            var hasOdds = false;
            if (isExacta) {
                for (var _i = 0, _b = Object.values(nonKombineGroups); _i < _b.length; _i++) {
                    var items = _b[_i];
                    if (items.length === 2) {
                        var v = parseFloat(getGroupExactaOdds(items));
                        if (!isNaN(v) && v > 1) {
                            total *= v;
                            hasOdds = true;
                        }
                    }
                }
            }
            else {
                for (var _c = 0, nonKombineItems_1 = nonKombineItems; _c < nonKombineItems_1.length; _c++) {
                    var item = nonKombineItems_1[_c];
                    var v = parseFloat(getOddsForItem(item));
                    if (!isNaN(v) && v > 1) {
                        total *= v;
                        hasOdds = true;
                    }
                }
            }
            return hasOdds ? total.toFixed(2) : '-';
        }
        return '-';
    };
    var maxAllowedProfit = 7500000;
    var totalOddsStr = getTotalOdds();
    var totalOddsNum = parseFloat(totalOddsStr);
    var maxProfit = !isNaN(totalOddsNum) && totalOddsNum > 0 ? couponAmount * totalOddsNum : 0;
    var isOverMaxProfit = maxProfit > maxAllowedProfit;
    var hasContent = isLongterm ? !!longtermItem : (isFob ? allFobItems.length > 0 : mutuelItems.length > 0);
    var canPlay = hasContent && !isOverLimit && !isOverMaxProfit && !tjkBetSlipOptions.inProgress;
    var removeItem = function (item) {
        var isKombineItem = Number(item.bettingType.id) === 1883;
        var idx = tjkBetslipStore.findIndex(function (el) {
            return el.hippodrome.id === item.hippodrome.id &&
                el.bettingType.id === item.bettingType.id &&
                (isKombineItem ? el.run.no === item.run.no : el.bettingSubType === item.bettingSubType) &&
                Number(el.horse.no) === Number(item.horse.no);
        });
        if (idx !== -1)
            tjkBetslipStore.splice(idx, 1);
        updateBetCount.status = true;
        tjkBetSlipActionSubject.next(null);
        forceUpdate();
    };
    var removeMutuelItem = function (item) {
        var idx = tjkBetslipStore.findIndex(function (el) {
            return el.hippodrome.id === item.hippodrome.id &&
                el.bettingType.id === item.bettingType.id &&
                el.bettingSubType === item.bettingSubType &&
                Number(el.horse.no) === Number(item.horse.no) &&
                el.column === item.column;
        });
        if (idx !== -1)
            tjkBetslipStore.splice(idx, 1);
        updateBetCount.status = true;
        tjkBetSlipActionSubject.next(null);
        forceUpdate();
    };
    var removeLongtermItem = function () {
        if (!longtermItem)
            return;
        var idx = tjkBetslipStore.indexOf(longtermItem);
        if (idx !== -1)
            tjkBetslipStore.splice(idx, 1);
        updateBetCount.status = true;
        tjkBetSlipActionSubject.next(null);
        forceUpdate();
    };
    var playCoupon = function (save) {
        if (save === void 0) { save = false; }
        tjkBetSlipOptions.inProgress = true;
        forceUpdate();
        var promise = isLongterm ? PlayTjkLongtermCoupon(save) : (isFob ? PlayTjkFobCoupon(save) : PlayTjkCoupon(save));
        promise.then(function (result) {
            var _a;
            var normalized = Array.isArray(result)
                ? { status: result.every(function (r) { return (r === null || r === void 0 ? void 0 : r.status) === true; }), isMultiFob: true }
                : result;
            if ((normalized === null || normalized === void 0 ? void 0 : normalized.status) === true && !save) {
                clearTjkBetSlip();
                tjkBetSlipVisibleSubject.next('close');
                modalServiceSubject.next({
                    title: 'Kuponunuz Oynandı',
                    content: 'Kuponunuz başarıyla oynandı.',
                    confirm: {
                        sure: { label: 'At Yarışı Kuponlarım', action: function () { return navigate('/hesabim/tjk/devam-edenler'); } },
                        cancel: { label: 'Bültene Dön', action: function () { return navigate(-1); } },
                    },
                });
            }
            else if ((normalized === null || normalized === void 0 ? void 0 : normalized.status) && save) {
                modalServiceSubject.next({
                    title: 'Kuponunuz Kaydedildi',
                    content: 'Kuponunuz başarıyla kaydedildi.',
                    confirm: {
                        sure: { label: 'Kayıtlı Kuponlarım', action: function () { return navigate('/hesabim/tjk/kayitli'); } },
                        cancel: { label: 'Yeni Kupon', action: function () { return navigate(-1); } },
                    },
                });
            }
            else if (!(normalized === null || normalized === void 0 ? void 0 : normalized.isMultiFob) && normalized) {
                var errData = (_a = normalized.data) === null || _a === void 0 ? void 0 : _a.error;
                modalServiceSubject.next({
                    title: 'Hata',
                    content: (errData === null || errData === void 0 ? void 0 : errData.error_description) ||
                        (typeof normalized.message === 'object' ? JSON.stringify(normalized.message) : normalized.message) ||
                        'Bir hata oluştu.',
                    confirm: { cancel: { label: 'Tamam' } },
                });
            }
            tjkBetSlipOptions.inProgress = false;
            forceUpdate();
        });
    };
    var hippodromeLabel = isLongterm
        ? (((_b = longtermItem === null || longtermItem === void 0 ? void 0 : longtermItem.hippodrome) === null || _b === void 0 ? void 0 : _b.location) || ((_c = longtermItem === null || longtermItem === void 0 ? void 0 : longtermItem.hippodrome) === null || _c === void 0 ? void 0 : _c.hippodrome) || '')
        : (((_d = tjkBetSlipOptions.hippodrome) === null || _d === void 0 ? void 0 : _d.location) || '');
    var betTypeName = ((_e = tjkBetSlipOptions.bettingType) === null || _e === void 0 ? void 0 : _e.name) || '';
    // Müşterek horse list — group by column
    var mutuelByColumn = {};
    for (var _g = 0, mutuelItems_1 = mutuelItems; _g < mutuelItems_1.length; _g++) {
        var item = mutuelItems_1[_g];
        var col = item.column || 1;
        if (!mutuelByColumn[col])
            mutuelByColumn[col] = [];
        mutuelByColumn[col].push(item);
    }
    return (_jsxs("div", __assign({ className: "tjk-bilet-onay-page" }, { children: [_jsxs("div", __assign({ className: "bilet-onay-header" }, { children: [_jsx("button", __assign({ className: "bilet-onay-back", onClick: function () { return navigate(-1); } }, { children: "\u2190" }), void 0), _jsxs("div", __assign({ className: "bilet-onay-header-info" }, { children: [_jsx("span", __assign({ className: "bilet-onay-type" }, { children: betTypeName }), void 0), _jsxs("span", __assign({ className: "bilet-onay-hip" }, { children: [hippodromeLabel, !isFob && !isLongterm && " \u00B7 ".concat(tjkBetSlipOptions.bettingSubType, ".Ko\u015Fu")] }), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "bilet-onay-body" }, { children: [!isFob && !isLongterm && Object.entries(mutuelByColumn).map(function (_a) {
                        var col = _a[0], horses = _a[1];
                        var isDouble = [14].includes(tjkBetSlipOptions.bettingType.id);
                        var displaySubType;
                        if (isDouble) {
                            displaySubType = "".concat(tjkBetSlipOptions.bettingSubType.split('-')[Number(col) - 1]);
                        }
                        return (_jsxs("div", __assign({ className: "bilet-onay-column-group" }, { children: [Number(Object.keys(mutuelByColumn).length) > 1 && (_jsxs("div", __assign({ className: "bilet-onay-column-label" }, { children: [col, ". ", isDouble ? 'Kolon' : tjkBettingTypesMap2[tjkBetSlipOptions.bettingType.id].columnLabel, " ", displaySubType && "(".concat(displaySubType, " .Ko\u015Fu)"), " "] }), void 0)), horses.map(function (item, i) { return (_jsxs("div", __assign({ className: "bilet-onay-item" }, { children: [_jsx("span", __assign({ className: "bilet-onay-horse-no" }, { children: item.horse.no }), void 0), _jsx("span", __assign({ className: "bilet-onay-horse-name" }, { children: item.horse.name }), void 0), _jsx("button", __assign({ className: "bilet-onay-remove", onClick: function () { return removeMutuelItem(item); } }, { children: _jsx("img", { src: Trash, width: 13, alt: "", style: { filter: 'invert(1)' } }, void 0) }), void 0)] }), i)); })] }), col));
                    }), isFob && kombineItems.length > 0 && (_jsxs("div", __assign({ className: "bilet-onay-column-group" }, { children: [_jsxs("div", __assign({ className: "bilet-onay-column-label" }, { children: ["Kombine \u2014 ", kombineItems.length, " Ayak"] }), void 0), kombineItems.map(function (item, i) {
                                var _a, _b, _c;
                                var odds = (_c = (_b = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds) === null || _b === void 0 ? void 0 : _b[Number(item.horse.no)]) === null || _c === void 0 ? void 0 : _c.win_odds;
                                return (_jsxs("div", __assign({ className: "bilet-onay-item" }, { children: [_jsxs("span", __assign({ className: "bilet-onay-run-no" }, { children: [item.run.no, ".K"] }), void 0), _jsx("span", __assign({ className: "bilet-onay-horse-no" }, { children: item.horse.no }), void 0), _jsx("span", __assign({ className: "bilet-onay-horse-name" }, { children: item.horse.name }), void 0), _jsx("span", __assign({ className: "bilet-onay-odds" }, { children: odds > 1 ? Number(odds).toFixed(2) : '-' }), void 0), _jsx("button", __assign({ className: "bilet-onay-remove", onClick: function () { return removeItem(item); } }, { children: _jsx("img", { src: Trash, width: 13, alt: "", style: { filter: 'invert(1)' } }, void 0) }), void 0)] }), i));
                            })] }), void 0)), isFob && Object.entries(nonKombineGroups).map(function (_a) {
                        var key = _a[0], items = _a[1];
                        var isExacta = tjkFobHorseSelectionTypes.includes(Number(items[0].bettingType.id));
                        var label = "".concat(items[0].hippodrome.location, " ").concat(items[0].run.no, ".Ko\u015Fu \u00B7 ").concat(items[0].bettingType.name);
                        return (_jsxs("div", __assign({ className: "bilet-onay-column-group" }, { children: [_jsx("div", __assign({ className: "bilet-onay-column-label" }, { children: label }), void 0), items.map(function (item, i) {
                                    return (_jsxs("div", __assign({ className: "bilet-onay-item" }, { children: [isExacta && _jsxs("span", __assign({ className: "bilet-onay-run-no" }, { children: [i + 1, ". At"] }), void 0), _jsx("span", __assign({ className: "bilet-onay-horse-no" }, { children: item.horse.no }), void 0), _jsx("span", __assign({ className: "bilet-onay-horse-name" }, { children: item.horse.name }), void 0), !isExacta && _jsx("span", __assign({ className: "bilet-onay-odds" }, { children: getOddsForItem(item) }), void 0), _jsx("button", __assign({ className: "bilet-onay-remove", onClick: function () { return removeItem(item); } }, { children: _jsx("img", { src: Trash, width: 13, alt: "", style: { filter: 'invert(1)' } }, void 0) }), void 0)] }), i));
                                }), isExacta && items.length === 2 && (_jsxs("div", __assign({ className: "bilet-onay-exacta-odds" }, { children: ["Oran: ", _jsx("strong", { children: getGroupExactaOdds(items) }, void 0)] }), void 0))] }), key));
                    }), isLongterm && longtermItem && (_jsxs("div", __assign({ className: "bilet-onay-column-group" }, { children: [_jsx("div", __assign({ className: "bilet-onay-column-label" }, { children: longtermItem.hippodrome.hippodrome }), void 0), _jsxs("div", __assign({ className: "bilet-onay-item" }, { children: [_jsx("span", __assign({ className: "bilet-onay-horse-name" }, { children: longtermItem.horse.description }), void 0), _jsx("span", __assign({ className: "bilet-onay-odds" }, { children: longtermItem.horse.win_odds > 1 ? Number(longtermItem.horse.win_odds).toFixed(2) : '-' }), void 0), _jsx("button", __assign({ className: "bilet-onay-remove", onClick: removeLongtermItem }, { children: _jsx("img", { src: Trash, width: 13, alt: "", style: { filter: 'invert(1)' } }, void 0) }), void 0)] }), void 0)] }), void 0)), !hasContent && (_jsx("p", __assign({ className: "bilet-onay-empty" }, { children: "Kuponunuz bo\u015F." }), void 0))] }), void 0), (isOverLimit || isOverMaxProfit || tjkBetSlipOptions.errorMessage) && (_jsx("div", __assign({ className: "bilet-onay-error" }, { children: isOverLimit
                    ? "Toplam bahis tutar\u0131 ".concat(currencyFormat(maxCouponAmount), "\u20BA'yi ge\u00E7emez.")
                    : isOverMaxProfit
                        ? "Maksimum kazan\u00E7 ".concat(currencyFormat(maxAllowedProfit), "\u20BA'den fazla olamaz.")
                        : tjkBetSlipOptions.errorMessage }), void 0)), _jsxs("div", __assign({ className: "bilet-onay-stats" }, { children: [_jsxs("div", __assign({ className: "bilet-onay-stat-row" }, { children: [_jsx("span", { children: (isFob || isLongterm) ? 'Toplam Oran' : 'Bahis' }, void 0), _jsx("strong", { children: (isFob || isLongterm) ? totalOddsStr : betCount }, void 0)] }), void 0), _jsxs("div", __assign({ className: "bilet-onay-stat-row" }, { children: [_jsx("span", { children: "Kupon Bedeli" }, void 0), _jsxs("strong", { children: [currencyFormat(couponAmount), "\u20BA"] }, void 0)] }), void 0), (isFob || isLongterm) && maxProfit > 0 && (_jsxs("div", __assign({ className: "bilet-onay-stat-row" }, { children: [_jsx("span", { children: "Max Kazan\u00E7" }, void 0), _jsxs("strong", __assign({ style: { color: 'var(--color-success)' } }, { children: [currencyFormat(maxProfit), "\u20BA"] }), void 0)] }), void 0)), _jsxs("div", __assign({ className: "bilet-onay-stat-row bilet-onay-misli-row" }, { children: [_jsx("span", { children: "Misli" }, void 0), _jsx("input", { type: "number", pattern: "^[0-9\\b]+$", className: "bilet-onay-misli-input", value: tjkBetSlipOptions.betSlipMultiply || '', min: 1, onChange: function (e) { return setTjkBetSlipMultiply(e.target.value); }, onBlur: function () { if (!tjkBetSlipOptions.betSlipMultiply)
                                    setTjkBetSlipMultiply(1); }, onPaste: function (e) { e.preventDefault(); return false; } }, void 0)] }), void 0), member.id && (_jsxs("div", __assign({ className: "bilet-onay-stat-row" }, { children: [_jsx("span", { children: "Puan Kullan" }, void 0), _jsxs("label", __assign({ className: "bilet-onay-checkbox-label" }, { children: [_jsx("input", { type: "checkbox", checked: tjkBetSlipOptions.usePointBalance, onChange: function () { return setTjkUsePointBalance(!tjkBetSlipOptions.usePointBalance); } }, void 0), (member.point_balance / 100).toFixed(2), "\u20BA"] }), void 0)] }), void 0))] }), void 0), _jsxs("div", __assign({ className: "bilet-onay-actions" }, { children: [_jsx("button", __assign({ className: "bilet-onay-btn bilet-onay-btn-trash", onClick: function () { clearTjkBetSlip(); navigate(-1); } }, { children: _jsx("img", { src: Trash, width: 18, height: 18, alt: "" }, void 0) }), void 0), _jsx("button", __assign({ className: "bilet-onay-btn bilet-onay-btn-play".concat(canPlay ? ' active' : ''), disabled: !canPlay, onClick: function () { return playCoupon(false); } }, { children: tjkBetSlipOptions.inProgress ? 'OYNANIYOR...' : 'OYNA' }), void 0), _jsx("button", __assign({ className: "bilet-onay-btn bilet-onay-btn-save", onClick: function () { return playCoupon(true); } }, { children: _jsx("img", { src: Save, style: { filter: "invert(1)" }, width: 18, height: 18, alt: "" }, void 0) }), void 0)] }), void 0)] }), void 0));
}
